import React, { useCallback, useEffect, useState } from "react";

export const useArrowButtons = (carouselApi) => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const scrollPrev = useCallback(() => {
    if (!carouselApi) return;
    carouselApi.scrollPrev();
  }, [carouselApi]);

  const scrollNext = useCallback(() => {
    if (!carouselApi) return;
    carouselApi.scrollNext();
  }, [carouselApi]);

  const onSelect = useCallback((carouselApi) => {
    setPrevBtnDisabled(!carouselApi.canScrollPrev());
    setNextBtnDisabled(!carouselApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!carouselApi) return;

    onSelect(carouselApi);
    carouselApi.on("select", onSelect);
    carouselApi.on("reInit", onSelect);
  }, [carouselApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    scrollPrev,
    scrollNext
  };
};

const CarouselArrowButton = ({ 
  direction, 
  onClick, 
  disabled, 
  theme, 
  isAnimating 
}) => {
  const getArrowClass = () => {
    if (theme === 'light') {
      return `carousel__arrow flow circle-icon cursor-pointer rounded-full border-gradient-button disabled:cursor-not-allowed hover:bg-soft_green/30 hover:border-gradient-button-hover focus:bg-soft_green/30 focus:shadow-[0px_0px_50px_0px_rgba(0,0,0,0.05)_inset,0px_20px_50px_-20px_rgba(0,0,0,0.20)]`;
    }
    // Dark theme
    return `carousel__arrow flow circle-icon cursor-pointer disabled:cursor-not-allowed border-gradient-button hover:border-gradient-button-hover bg-[#0B302C33]`;
  };

  const arrowStyle = {
    width: '3rem',
    height: '3rem',
    transition: 'all 0.3s ease',
    zIndex: 10,
    display: 'flex',  
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(40px)',
    boxShadow: '0 20px 50px -20px rgba(0, 0, 0, 0.2),  inset 0 0 50px 0 rgba(0, 0, 0, 0.05)',
  };

  return (
    <button
      className={`cascade-slider_arrow cascade-slider_arrow-${direction} ${direction}-arrow ${getArrowClass()}`}
      onClick={onClick}
      disabled={disabled || isAnimating}
      aria-label={`${direction === 'left' ? 'Previous' : 'Next'} slide`}
      style={arrowStyle}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none" className={theme === 'light' ? 'text-dark_green' : 'text-green'}>
        {direction === 'left' ? (
          <path d="M9.00024 1.92871L1.92918 8.99978L9.00024 16.0708" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        ) : (
          <path d="M7.99976 1.92871L15.0708 8.99978L7.99976 16.0708" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        )}
      </svg>
    </button>
  );
};

export default CarouselArrowButton;
